import React from "react";

export default function Button({
  as = "a",
  href,
  children,
  variant = "primary",
  className = "",
  ...props
}) {
  const Comp = as;

  const base = [
    "inline-flex items-center justify-center gap-2",
    "rounded-xl px-5 py-3 text-sm font-semibold",
    "transition-all duration-200",
    "focus:outline-none focus-visible:ring-2 focus-visible:ring-cyan-300/60",
    "focus-visible:ring-offset-2 focus-visible:ring-offset-[#070A0F]",
    "disabled:opacity-50 disabled:pointer-events-none",
  ].join(" ");

  const styles =
    variant === "primary"
      ? [
          "bg-cyan-300 text-[#070A0F]",
          "hover:bg-cyan-200",
          "shadow-[0_8px_24px_rgba(34,211,238,0.16)]",
        ].join(" ")
      : variant === "secondary"
      ? [
          "border border-white/10 bg-white/[0.03] text-white",
          "hover:bg-white/[0.06] hover:border-white/15",
        ].join(" ")
      : [
          "bg-transparent text-white/75",
          "hover:text-white",
        ].join(" ");

  return (
    <Comp href={href} className={`${base} ${styles} ${className}`} {...props}>
      {children}
    </Comp>
  );
}
